class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-reviews-track]');
    this.previous = this.querySelector('[data-reviews-prev]');
    this.next = this.querySelector('[data-reviews-next]');
    this.dots = this.querySelector('[data-reviews-dots]');
    if (!this.track || !this.previous || !this.next || !this.dots) return;
    const update = () => {
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      [...this.dots.children].forEach((dot, dotIndex) => dot.toggleAttribute('aria-current', dotIndex === index));
    };
    const pages = Math.max(1, Math.ceil(this.track.scrollWidth / Math.max(this.track.clientWidth, 1)));
    for (let index = 0; index < pages; index += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'reviews-trust__dot';
      dot.setAttribute('aria-label', `Show reviews ${index + 1}`);
      dot.addEventListener('click', () => this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' }));
      this.dots.append(dot);
    }
    this.previous.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' }));
    this.next.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' }));
    this.track.addEventListener('scroll', update, { passive: true });
    update();
  }
}
if (!customElements.get('reviews-carousel')) customElements.define('reviews-carousel', ReviewsCarousel);
